// extracted by mini-css-extract-plugin
export var label = "_r8-0";
export var link = "_r8-1";